/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-25 16:35:23
 */
import React from "react";
import lazyLoad from "@/routers/utils/lazyLoad";
import { LayoutIndex } from "@/routers/constant";
import { RouteObject } from "@/routers/interface";
import Billing from "@/pages/Subscription/Billing/index";
import Payment from "@/pages/Subscription/Payment/index";
import PaymentDetail from "@/pages/Subscription/Payment/detail";
import Plan from "@/pages/Subscription/Subscribe/index";
const Subscription: Array<RouteObject> = [
	{
		element: <LayoutIndex />,
		meta: {
			title: "Billing",
			path: "/billing",
			icon: null,
			hideInMenu: true
		},
		children: [
			{
				path: "/billing/history",
				// element: lazyLoad(React.lazy(() => import("@/pages/AutomatedRules/ManageRules/index"))),
				element: <Billing />,
				meta: {
					requiresAuth: true,
					hideInMenu: true,
					title: "Billing",
					key: "billing",
					hideInMenu: true
				}
			},
			{
				path: "/billing/payment",
				// element: lazyLoad(React.lazy(() => import("@/pages/AutomatedRules/RulesMarket/index"))),
				element: <Payment />,
				meta: {
					requiresAuth: true,
					title: "Payment",
					hideInMenu: true,
					key: "payment"
				}
			},
			{
				path: "/billing/plan",
				// element: lazyLoad(React.lazy(() => import("@/pages/AutomatedRules/RulesMarket/index"))),
				element: <Plan />,
				meta: {
					requiresAuth: true,
					title: "Plan",
					hideInMenu: true,
					key: "plan"
				}
			}
		]
	}
];

export default Subscription;
